import React from 'react';
import { Button } from './Button';
import { ZapIcon, WorkflowIcon, DatabaseIcon, BrainCircuitIcon } from 'lucide-react';
export function AdvancedAutomation() {
  const capabilities = [{
    icon: WorkflowIcon,
    text: 'Route leads intelligently'
  }, {
    icon: ZapIcon,
    text: 'Trigger automated workflows'
  }, {
    icon: DatabaseIcon,
    text: 'Sync directly into CRMs'
  }, {
    icon: BrainCircuitIcon,
    text: 'Collect structured information'
  }];
  return <section className="w-full bg-[#0F0F0F] py-28 md:py-36 relative overflow-hidden" data-id="element-69">
      {/* Background Automation Visual */}
      <div className="absolute inset-0" data-id="element-70">
        <img src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920&q=80" alt="" className="w-full h-full object-cover opacity-10" data-id="element-71" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F0F0F]/95 via-[#0F0F0F]/90 to-[#0F0F0F]" data-id="element-72"></div>
      </div>

      <div className="max-w-6xl mx-auto px-8 md:px-12 text-center relative z-10" data-id="element-73">
        <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl lg:text-6xl mb-6 tracking-tight text-[#F5F5F5]" data-id="element-74">
          AI Automation Customisation Advanced
        </h2>
        <p className="font-['Inter'] font-light text-xl md:text-2xl text-[#A0A0A0] mb-10" data-id="element-75">
          Automate More Than Calls. Automate Your Entire Frontline.
        </p>

        <p className="font-['Inter'] text-lg text-[#A0A0A0] max-w-4xl mx-auto mb-16 leading-relaxed font-light" data-id="element-76">
          For businesses handling 500+ calls per month, unlock advanced
          capabilities that transform your AI answering service into a complete
          frontline automation platform.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-77">
          {capabilities.map((capability, index) => {
          const Icon = capability.icon;
          return <div key={index} className="bg-[#252525]/80 backdrop-blur-sm rounded-2xl p-8 border border-[#2A2A2A] hover:border-[#F1B530]/30 transition-all duration-300" data-id="element-78">
                <Icon className="w-10 h-10 text-[#F1B530] mx-auto mb-5" data-id="element-79" />
                <p className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-80">
                  {capability.text}
                </p>
              </div>;
        })}
        </div>

        {/* Workflow Visualization */}
        <div className="mb-16 relative" data-id="element-81">
          <div className="bg-[#252525]/60 backdrop-blur-sm rounded-2xl p-8 border border-[#2A2A2A] max-w-4xl mx-auto" data-id="element-82">
            <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80" alt="Automation workflow visualization" className="w-full h-64 object-cover rounded-xl opacity-70" data-id="element-83" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-84">
              <div className="bg-[#F1B530]/10 backdrop-blur-md border border-[#F1B530]/30 rounded-xl px-8 py-4" data-id="element-85">
                <p className="font-['Inter'] text-[#F1B530] font-semibold text-lg" data-id="element-86">
                  Complete Workflow Automation
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#252525]/60 backdrop-blur-sm rounded-2xl p-10 border border-[#2A2A2A] mb-12 max-w-3xl mx-auto" data-id="element-87">
          <h3 className="font-['Inter'] font-semibold text-xl mb-6 text-[#F5F5F5]" data-id="element-88">
            Extended Capabilities Include:
          </h3>
          <ul className="font-['Inter'] text-[#A0A0A0] space-y-3 text-left max-w-2xl mx-auto font-light" data-id="element-89">
            <li data-id="element-90">• Support multi-step decision trees</li>
            <li data-id="element-91">• Extended conversational capabilities</li>
            <li data-id="element-92">• Custom API integrations</li>
            <li data-id="element-93">• Advanced data collection and processing</li>
            <li data-id="element-94">• Bespoke workflow automation</li>
          </ul>
        </div>

        <Button size="lg" data-id="element-95">Contact Sales</Button>
      </div>
    </section>;
}